import { useMemo } from 'react'
import { Flex } from '@mantine/core'

import type { GoalsWidgetItemProps } from '@/components/GoalsWidgetItem/GoalsWidgetItem.types'
import { Progress } from '@/components/Progress/Progress'
import { Text } from '@/components/Text/Text'

import { formatMoney } from '@/helpers/formatMoney.helper'

export function GoalsWidgetItem({ goal }: GoalsWidgetItemProps) {
  const percentageValue = useMemo(() => {
    if (!goal?.amount) return 0

    return Math.floor(((goal.collectedAmount || 0) / goal.amount) * 100)
  }, [goal])

  return (
    <Flex direction="column" gap={8}>
      <Progress value={percentageValue} />
      <Flex gap={12} justify="space-between">
        <Text variant="body_2_medium_black">{goal.name}</Text>
        <Text variant="body_3_red">{formatMoney(goal.amount)}</Text>
      </Flex>
    </Flex>
  )
}
